import { useState, useEffect } from 'react';
import bot from '../images/happy.png';
import Residential from './Residential';
import Commercial from './Commercial';
import LoadingDots from './LoadingDots';

import you from "../images/boy.png";

const PropertyType = () => {
    const [time, setTime] = useState(new Date());
    const [showFrame, setShowFrame] = useState(null); // Combine the two frame states
    const [loading, setLoading] = useState(true);

    // Update time when the component mounts
    useEffect(() => {
        setTime(new Date());
    }, []);

    // Simulate data fetching and set loading to false after 2 seconds
    useEffect(() => {
        setTimeout(() => setLoading(false), 2000); 
    }, []);

    // Handle showing the appropriate frame based on user selection
    const handleShowFrame = (frameType) => {
        setShowFrame(frameType);
    };

    return (
        <>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>

            <div className="frame1">
                <b>Akaay Infra: </b>What type of property are you looking for?
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: '10px'
                }}>
                    <button className="details-button" onClick={() => handleShowFrame('residential')}>Residential</button>
                    <button className="details-button" onClick={() => handleShowFrame('commercial')}>Commercial</button>
                </div>
            </div>

            {/* Conditional rendering based on selected frame */}
            {showFrame === 'residential' && (
                <>
                    <div className="you-time">
                        <img src={you} alt="boy" className="boy" />
                        You {time.toLocaleTimeString()}
                    </div>
        
                    <div className="you-message">
                        <div className="frame2">Residential</div>
                    </div>
                    {loading ? (
                        <div className='frame1'><LoadingDots /></div>
                    ) : (
                        <Residential />
                    )}
                </>
            )}

            {showFrame === 'commercial' && (
                <>
                    <div className="you-time">
                        <img src={you} alt="boy" className="boy" />
                        You {time.toLocaleTimeString()}
                    </div>
        
                    <div className="you-message">
                        <div className="frame2">Commercial</div>
                    </div>
                    {loading ? (
                        <div className='frame1'><LoadingDots /></div>
                    ) : (
                        <Commercial />
                    )}
                </>
            )}
        </>
    );
};

export default PropertyType;
